"use client"
import React, { useState, useEffect } from "react";
import { Container, li, Col } from "react-bootstrap";

import "@/components/shared/LocationHoursText.css";

var moment = require("moment");

const LocationHoursText = props => {
  const [hasHours, setHasHours] = useState(false);
  const [monday, setMonday] = useState(null);
  const [tuesday, setTuesday] = useState(null);
  const [wednesday, setWednesday] = useState(null);
  const [thursday, setThursday] = useState(null);
  const [friday, setFriday] = useState(null);
  const [saturday, setSaturday] = useState(null);
  const [sunday, setSunday] = useState(null);

  const highlightDOW = props.highlightDOW;
  const dow = moment().weekday();

  useEffect(() => {
    var location = props.location;
    if (
      location != null &&
      location.hours != null &&
      typeof location.hours === "string"
    ) {
      var hoursObj = JSON.parse(location.hours);
      setMonday(getDOWTimeString(hoursObj, "MONDAY"));
      setTuesday(getDOWTimeString(hoursObj, "TUESDAY"));
      setWednesday(getDOWTimeString(hoursObj, "WEDNESDAY"));
      setThursday(getDOWTimeString(hoursObj, "THURSDAY"));
      setFriday(getDOWTimeString(hoursObj, "FRIDAY"));
      setSaturday(getDOWTimeString(hoursObj, "SATURDAY"));
      setSunday(getDOWTimeString(hoursObj, "SUNDAY"));

      setHasHours(true);
    } else {
      setHasHours(false);
    }
  }, [props]);

  const getDOWTimeString = (hours, dow) => {
    var dayObject = hours.periods.find(period => period.open.day === dow);
    if (dayObject && dayObject.open && dayObject.close) {
      // create the day from the name of the day
      var startOfDay = moment()
        .hours(dayObject.open.time.hour)
        .minutes(dayObject.open.time.minute);
      // .add(minutes, "minutes");
      var endOfDay = moment()
        .hours(dayObject.close.time.hour)
        .minutes(dayObject.close.time.minute);
      // .add(minutes, "minutes");
      if (dayObject.open.day !== dayObject.close.day) {
        endOfDay = endOfDay.add(1, "days");
      }

      return startOfDay.format("h:mm a") + " - " + endOfDay.format("h:mm a");
    } else {
      return "Closed";
    }
  };

  if (hasHours) {
    return (
      <ul className="location-hours-text">
        <li className={highlightDOW ? (dow === 1 ? "highlight-day" : "") : ""}>
          <span>Monday</span>
          <span>{monday}</span>
        </li>
        <li className={highlightDOW ? (dow === 2 ? "highlight-day" : "") : ""}>
          <span>Tuesday</span>
          <span>{tuesday}</span>
        </li>
        <li className={highlightDOW ? (dow === 3 ? "highlight-day" : "") : ""}>
          <span>Wednesday</span>
          <span>{wednesday}</span>
        </li>
        <li className={highlightDOW ? (dow === 4 ? "highlight-day" : "") : ""}>
          <span>Thursday</span>
          <span>{thursday}</span>
        </li>
        <li className={highlightDOW ? (dow === 5 ? "highlight-day" : "") : ""}>
          <span>Friday</span>
          <span>{friday}</span>
        </li>
        <li className={highlightDOW ? (dow === 6 ? "highlight-day" : "") : ""}>
          <span>Saturday</span>
          <span>{saturday}</span>
        </li>
        <li className={highlightDOW ? (dow === 7 ? "highlight-day" : "") : ""}>
          <span>Sunday</span>
          <span>{sunday}</span>
        </li>
      </ul>
    );
  } else {
    return (
      <ul className="location-hours-text">
        <li>
          <span>No hours provided.</span>
        </li>
      </ul>
    );
  }
};
export default LocationHoursText;
